import { Modal, Table } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { shipmentTrackingNumber } from 'redux/slices/shipment-tracking/ShipmentTrackingSlice';
import { Badge } from 'components';
const DeliveryFollowListModal = ({ data, ...other }) => {
  const deliveryNumber = useSelector(shipmentTrackingNumber);

  const column = [
    {
      key: 'tarih',
      title: 'Tarih',
      dataIndex: 'gun',
    },
    {
      key: 'saat',
      title: 'Saat',
      dataIndex: 'saat',
    },
    {
      key: 'durum',
      title: 'Durum',
      dataIndex: 'durum_tr',
    },
    {
      key: 'detay',
      title: 'Detay',
      dataIndex: 'aciklama',
    },
    {
      key: 'lokasyon',
      title: 'Lokasyon',
      dataIndex: 'lokasyon',
    },
  ];

  return (
    <Modal
      {...other}
      footer={null}
      destroyOnClose={true}
      maskClosable={false}
      width={'100%'}
      bodyStyle={{ maxHeight: '75vh', overflowY: 'auto' }}
      centered={false}
    >
      <div className="flex flex-col gap-y-3 py-5">
        <div className="flex items-center gap-x-1">
          Takip No: <Badge text={deliveryNumber} />
        </div>
        <div className="flex items-center gap-x-1">
          Gönderi Durumu:
          <Badge text={data?.[0].durum_tr} />
        </div>
      </div>
      <Table
        dataSource={data}
        rowClassName={(_, index) => {
          if (index % 2 !== 0 && index !== 0) {
            return 'bg-sky';
          } else if (index === 0) {
            return 'bg-green-light';
          }
        }}
        columns={column}
        pagination={false}
      />
    </Modal>
  );
};

export default DeliveryFollowListModal;

DeliveryFollowListModal.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};
